// FIXME: https://foresightdata.atlassian.net/browse/MAGGIE-5225

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { debounce, isEqual } from 'lodash-es';
import { useCallback, useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { captureFormValidationError } from '../../../util/SentryUtils';
import { useSaveNote } from '../hooks/useSaveNote';
import { useLexicalContext } from '../provider/LexicalProvider';

const DebounceAutoSaveTime = 500;

export function AutoSavePlugin() {
  const [editor] = useLexicalComposerContext();
  const { noteData } = useLexicalContext();
  const {
    watch,
    trigger,
    formState: { errors },
  } = useFormContext();
  const saveNote = useSaveNote();
  const debouncedSave = useRef(debounce((noteData) => saveNote(noteData), DebounceAutoSaveTime)).current;

  useEffect(() => {
    return () => {
      debouncedSave.cancel();
    };
  }, [debouncedSave, noteData]);

  const checkIfValidAndDebounceSave = useCallback(async () => {
    const isValid = await trigger();

    if (isValid) {
      debouncedSave(noteData);
    } else {
      captureFormValidationError('Autosave plugin', errors);
    }
  }, [trigger, debouncedSave, noteData, errors]);

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState, prevEditorState }) => {
      editorState.read(() => {
        const currentState = editorState.toJSON();
        const previousState = prevEditorState.toJSON();

        const hasStateChanged = !isEqual(currentState, previousState);

        if (hasStateChanged) {
          checkIfValidAndDebounceSave();
        }
      });
    });
  }, [checkIfValidAndDebounceSave, editor]);

  useEffect(() => {
    const subscription = watch((data, { type, name }) => {
      // attendees are set programmatically, so type will not be 'change'
      if (type === 'change' || (name === 'body.attendees' && data?.body?.attendees)) {
        checkIfValidAndDebounceSave();
      }
    });

    return () => subscription.unsubscribe();
  }, [checkIfValidAndDebounceSave, debouncedSave, watch]);

  return null;
}
